// extracted by mini-css-extract-plugin
export var box = "_92-1";
export var checked = "_92-2";
export var descriptionSpacer = "_92-9";
export var disabled = "_92-3";
export var icon = "_92-6";
export var input = "_92-0";
export var labelSpacer = "_92-8";
export var medium = "_92-5";
export var small = "_92-4";
export var text = "_92-7";